import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createReportIssue,
  getIdReportIssue,
  getInventory,
  updateReportIssue,
} from "./inventoryAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchInventory = createAsyncThunk(
  "Inventory/fetchInventory",
  async (payload) => {
    const response = await getInventory(payload);
    return response;
  }
);

export const addReportIssue = createAsyncThunk(
  "Inventory/addReportIssue",
  async (payload) => {
    const response = await createReportIssue(payload);
    return response;
  }
);

export const editReportIssue = createAsyncThunk(
  "Inventory/editReportIssue",
  async (payload) => {
    const response = await updateReportIssue(payload);
    return response;
  }
);

export const fetchIdReportIssue = createAsyncThunk(
  "Inventory/fetchIdReportIssue",
  async (id) => {
    const response = await getIdReportIssue(id);
    return response;
  }
);

export const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInventory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdReportIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdReportIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addReportIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(addReportIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editReportIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(editReportIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = inventorySlice.actions;

export const selectInventory = (state) => state.inventory.data;
export const selectIdReportIssue = (state) => state.inventory.dataId;
export const selectLoading = (state) => state.inventory.loading;
export const selectError = (state) => state.inventory.error;
export const selectPageNo = (state) => state.inventory.pageNo;
export const selectPageSize = (state) => state.inventory.pageSize;
export const selectTotalRecord = (state) => state.inventory.totalRecord;
export const selectSelected = (state) => state.inventory.selected;
export const selectResult = (state) => state.inventory.result;

export default inventorySlice.reducer;
